// material
import {  Dialog as MuiDialog,  DialogTitle,  DialogContent,} from '@mui/material';
import PropTypes from 'prop-types';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material/styles';
import Scrollbar from './Scrollbar';
import CloseIcon from '@mui/icons-material/Close';
import IconButton from '@mui/material/IconButton';

// ----------------------------------------------------------------------

export default function Dialog({ open, onClose, children, title }) {

  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down('md'));
  let content;

  if (fullScreen) {
    content = (
      <Scrollbar>
        <DialogContent>
          {children}
        </DialogContent>
      </Scrollbar>
    );
  } else {
    content = (
      <DialogContent style={{ paddingTop: 20, overflow: 'auto', minHeight: '50vh' }}>
        {children}
      </DialogContent>
    );
  }

  return (
    <MuiDialog
      open={open}
      onClose={onClose}
      maxWidth='md'
      fullWidth={true}
      fullScreen={fullScreen}
    >
      <DialogTitle sx={{ m: 0, p: 2 }}>
        {title}
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      {content}
    </MuiDialog>
  );
}

Dialog.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func.isRequired,
  children: PropTypes.node.isRequired,
  title: PropTypes.node.isRequired
};
